import React from 'react';

const Object_Constructors = () => {
  return (
    <div >
      <h1>Object_Constructors</h1>
      <p>Placeholder component for: "Object Constructors"</p>
    </div>
  );
};

export default Object_Constructors;
